const SalesRole = ({ title, description }) => (
  <div>
    <p className="font-display font-semibold text-3xl lg:text-4xl tracking-tight leading-none text-paper">{title}</p>
    <p className="mt-3 text-lg leading-snug text-paper text-pretty">{description}</p>
  </div>
);

export const ManifestoBand = () => {
  return (
    <section id="system" className="bg-paper border-t border-ink" data-testid="manifesto-band">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-12 md:py-20">
        <div>
          <div>
            <p className="font-mono text-base md:text-lg font-semibold uppercase tracking-[0.14em] text-ink text-pretty">
              What you actually buy
            </p>
            <h2 className="mt-4 font-display font-semibold tracking-[-0.03em] text-4xl md:text-5xl lg:text-6xl leading-[0.95] text-ink max-w-4xl text-balance">
              <span className="font-editorial italic font-medium text-cobalt">People.</span>{" "}
              <span className="font-editorial italic font-medium text-cobalt">Systems.</span>{" "}
              <span className="font-editorial italic font-medium text-flame">Creativity.</span>
            </h2>
          </div>
        </div>

        <div className="mt-10 border border-ink" data-testid="talent-band">
          <div className="grid grid-cols-1 md:grid-cols-2">
            {/* Who sells */}
            <div className="flex flex-col md:grid md:grid-rows-[auto_auto_1fr_9rem] bg-ink text-paper px-7 md:px-10 py-10 md:py-12 border-b md:border-b-0 md:border-r border-ink">
              <p className="font-mono text-base font-semibold uppercase tracking-[0.14em] text-flame">Who sells</p>
              <h3 className="mt-5 font-display font-semibold tracking-[-0.03em] text-3xl md:text-4xl lg:text-5xl leading-[0.95] text-paper text-balance">
                Top 1%{" "}
                <span
                  className="block md:inline font-editorial italic font-medium text-cobalt"
                  style={{ WebkitTextStroke: "2px #ffffff", paintOrder: "stroke" }}
                >
                  salespeople.
                </span>
              </h3>
              <p className="mt-5 text-xl md:text-2xl font-light leading-relaxed text-paper text-pretty">
                We book the meetings and close the deals. You get a team we recruit, train and manage.
              </p>
              <div className="mt-auto md:mt-0 pt-8">
                <div className="grid grid-cols-1 min-[400px]:grid-cols-2 gap-5 border-t border-paper/30 pt-6">
                  <SalesRole title="Setters" description="Start qualified conversations." />
                  <SalesRole title="Closers" description="Take the deal to signature." />
                </div>
              </div>
            </div>

            {/* Who builds */}
            <div className="flex flex-col md:grid md:grid-rows-[auto_auto_1fr_9rem] bg-cobalt text-white px-7 md:px-10 py-10 md:py-12">
              <p className="font-mono text-base font-semibold uppercase tracking-[0.14em] text-white">Who builds</p>
              <h3 className="mt-5 font-display font-semibold tracking-[-0.03em] text-3xl md:text-4xl lg:text-5xl leading-[0.95] text-balance">
                Top 1%{" "}
                <span
                  className="talent-ai-operators block md:inline font-editorial italic font-semibold"
                  style={{ fontWeight: 650, WebkitTextStroke: ".01em currentColor", paintOrder: "stroke fill" }}
                >
                  AI operators.
                </span>
              </h3>
              <p className="mt-5 text-xl md:text-2xl font-light leading-relaxed text-white text-pretty">
                We automate research, CRM updates and follow-up admin. Your reps spend that time with buyers.
              </p>
              <div className="mt-auto md:mt-0 pt-8">
                <p className="border-t border-white/35 pt-6 text-lg lg:text-xl leading-relaxed text-white text-pretty">
                  Sales reps spend <strong className="font-semibold">70% of their time</strong> on work other
                  than selling.
                </p>
                <a
                  href="https://www.salesforce.com/news/stories/sales-ai-statistics-2024/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-3 inline-block text-base leading-relaxed text-white underline decoration-white/60 underline-offset-4 hover:decoration-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white"
                >
                  Salesforce · State of Sales, 2024
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
